namespace Matrix.Data {
    export interface TestGroupForm {
        TestGroupCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        LastRunBatchId: Serenity.IntegerEditor;
        PassCount: Serenity.IntegerEditor;
        FailCount: Serenity.IntegerEditor;
        WarnCount: Serenity.IntegerEditor;
        IgnoreCount: Serenity.IntegerEditor;
        ErrorCount: Serenity.IntegerEditor;
        TestList: TestGroupTestsEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TestGroupForm extends Serenity.PrefixedContext {
        static formKey = 'Data.TestGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestGroupForm.init)  {
                TestGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = TestGroupTestsEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(TestGroupForm, [
                    'TestGroupCode', w0,
                    'Description', w0,
                    'LastRunBatchId', w1,
                    'PassCount', w1,
                    'FailCount', w1,
                    'WarnCount', w1,
                    'IgnoreCount', w1,
                    'ErrorCount', w1,
                    'TestList', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
